import React from 'react'
import PaidBIlls from '../../components/PaidBills/PaidBills'
import PageHeader from '../../PageHeader/PageHeader'

const NoGstBills = () => {
    return (
        <div>
            <div>
                <PageHeader
                    title={"No Gst Bill"}
                    description={""}
                />
            </div>
            <PaidBIlls noGst={true} />
        </div>
    )
}
export default NoGstBills